module.exports = __webpack_public_path__ + "static/img/2areaA_27.168a88b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/2areaA_27.png
// module id = 893
// module chunks = 1